var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csn-store-button"},[_c('app-store-link-wrapper',[_c('cs-button',_vm._b({attrs:{"corners":"rounded"}},'cs-button',_vm.$attrs,false),[_c('i',{class:_vm.icon}),_c('span',{staticClass:"csn-store__button-text"},[_vm._v(_vm._s(_vm.title))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }